import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import ourSharesCta from "data/our-shares-cta.json";

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

const filter = parallaxStyle.filter;

const ourSharesStyle = {

};

class OurSharesCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
        <CTASection cta={ourSharesCta} listIds={listIds} filterOpacity="0.4"/>
    );
  }
}

export default withStyles(ourSharesStyle)(OurSharesCTA);
